import * as Yup from "yup";
import * as ValidationRule from "../../utils/ValidationRule";
import * as ValidationTemplate from "../../utils/ValidationTemplate";
import * as DateFormatter from "../../utils/DateFormatter";


export default class User {

  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.credentialId = jsonResponse["credential-id"];
    this.organisationId = jsonResponse["organisation-id"];
    this.firstName = jsonResponse["first-name"];
    this.lastName = jsonResponse["last-name"];
    this.agentCode = jsonResponse["agent-code"];
    this.idNumber = jsonResponse["id-number"];
    this.idType = jsonResponse["id-type"];
    this.idExpiryDate = jsonResponse["id-expiry-date"] ? DateFormatter.prettifyDate(jsonResponse["id-expiry-date"]) : null;
    this.nationality = jsonResponse["nationality"];
    this.cellphoneNumber = jsonResponse["cellphone-number"];
    this.altCellphoneNumber = jsonResponse["alt-cellphone-number"];
    this.email = jsonResponse["email"];
    this.streetNumber = jsonResponse["street-number"];
    this.streetName = jsonResponse["street-name"];
    this.buildingName = jsonResponse["building-name"];
    this.suburb = jsonResponse["suburb"];
    this.city = jsonResponse["city"];
    this.province = jsonResponse["province"];
    this.postalCode = jsonResponse["postal-code"];
    this.active = jsonResponse["active"];
    this.deleted = jsonResponse["deleted"];
    this.isManager = jsonResponse["is-manager"];
    this.managerId = jsonResponse["manager-id"];
    this.remittancePartnerIdentifier = jsonResponse["remittance-partner-identifier"];
    this.dateCreated = DateFormatter.prettifyDate(jsonResponse["date-created"]);
    this.dateUpdated = jsonResponse["date-updated"] ? DateFormatter.prettifyDate(jsonResponse["date-updated"]) : null;

    this.fullName = this.firstName + " " + this.lastName;
  }

  static toJson = function (item) {

    let jsonObj = {};
    jsonObj["id"] = item.id;
    jsonObj["credential-id"] = item.credentialId;
    jsonObj["organisation-id"] = item.organisationId;
    jsonObj["first-name"] = item.firstName;
    jsonObj["last-name"] = item.lastName;
    jsonObj["agent-code"] = item.agentCode;
    jsonObj["id-number"] = item.idNumber;
    jsonObj["id-type"]= item.idType;
    jsonObj["id-expiry-date"] = item.idExpiryDate
    jsonObj["nationality"] = item.nationality;
    jsonObj["cellphone-number"] = item.cellphoneNumber;
    jsonObj["alt-cellphone-number"] = item.altCellphoneNumber;
    jsonObj["email"] = item.email;
    jsonObj["street-number"] = item.streetNumber;
    jsonObj["street-name"] = item.streetName;
    jsonObj["building-name"] = item.buildingName;
    jsonObj["suburb"] = item.suburb;
    jsonObj["city"] = item.city;
    jsonObj["province"] = item.province;
    jsonObj["postal-code"] = item.postalCode;
    jsonObj["active"] = item.active;
    jsonObj["deleted"] = item.deleted;
    jsonObj["is-manager"] = item.isManager;
    jsonObj["manager-id"] = item.managerId;
    jsonObj["remittance-partner-identifier"] = item.remittancePartnerIdentifier;

    return jsonObj;
  };

  static getOrganisationValidationConfig() {
    return [
      {
        dataField: "organisationId", dataLabel: "Organisation",
        type: "select", selectOptionValueField: "id", selectOptionTextField: "name",
        yup: Yup.string()
          .required('Organisation is required')
      }
    ];
  }

  static getValidationConfig = function () {

    return [
      {
        dataField: "id", dataLabel: "User Id",
        hideOnCreate: true, createValue: 0, readOnly: true,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "remittancePartnerIdentifier", dataLabel: "Remittance Partner Id",
        hideOnCreate: true, createValue: 0, readOnly: true
      },
      {
        dataField: "organisationId", dataLabel: "Organisation Id",
        hideOnCreate: true, createValue: 0, readOnly: true,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "credentialId", dataLabel: "Credential Id",
        hideOnCreate: true, createValue: 0, readOnly: true,
        yup: Yup.string()
          .required('Id is required')
      },
      {
        dataField: "firstName", dataLabel: "First Name",
        yup: Yup.string()
          .required('First Name is required')
      },
      {
        dataField: "lastName", dataLabel: "Last Name",
        yup: Yup.string()
          .required('Last Name is required')
      },
      {
        dataField: "idNumber", dataLabel: "ID Number",
        yup: Yup.string()
          .required('ID Number is required')
          .matches(/^\S*$/, 'No spaces are allowed')
      },
      {
        dataField: "idType", dataLabel: "ID Type", type: "select", selectOptions:
          [
            {value: "SA_ID", text: "SA ID"},
            {value: "FOREIGN_PASSPORT", text: "Foreign Passport"},
            {value: "FOREIGN_ID", text: "Foreign ID"},
            {value: "ASYLUM_PAPER", text: "Asylum Paper"}
          ]
      },
      {
        dataField: "idExpiryDate", dataLabel: "ID Expiry Date", type: "date"
      },
      {
        dataField: "nationality", dataLabel: "Nationality",
        type: "select-country",
        yup: Yup.string()
          .required('Nationality is required')
      },
      {
        dataField: "cellphoneNumber", dataLabel: "Cellphone Number",
        yup: ValidationRule.getCellphoneNumberRule("Cellphone Number", true)
      },
      {
        dataField: "altCellphoneNumber", dataLabel: "Alternative Cellphone Number",
        yup: ValidationRule.getCellphoneNumberRule("Alternative Cellphone Number", false)
      },
      {
        dataField: "email", dataLabel: "Email",
        yup: ValidationRule.getEmailAddressRule("Email Address", false)
      },
      {
        dataField: "agentCode", dataLabel: "Agent Code",
        yup: Yup.string()
          .required('Agent Code is required')
      },
      {
        dataField: "streetNumber", dataLabel: "Street Number"
      },
      {
        dataField: "streetName", dataLabel: "Street Name"
      },
      {
        dataField: "buildingName", dataLabel: "Building Name"
      },
      {
        dataField: "suburb", dataLabel: "Suburb"
      },
      {
        dataField: "city", dataLabel: "City"
      },
      {
        dataField: "province", dataLabel: "Province", type: "select-province"
      },
      {
        dataField: "postalCode", dataLabel: "Postal Code"
      },
      ValidationTemplate.getStandardActiveValidation(),
      ValidationTemplate.getStandardDeleteValidation(),
      {
        dataField: "dateCreated", dataLabel: "Date Created", readOnly: true
      },
      {
        dataField: "dateUpdated", dataLabel: "Date Updated", readOnly: true
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./src/domain/admin/User.js